import { useParams } from "react-router-dom";

import { UserGifList } from "components/feed/UserGifList";
import { MyGifList } from "components/feed/MyGifList";
import { CreatorInfo } from "components/profile/CreatorInfo";
import { useUserInfo } from "queries";
import { useUserName } from "hooks/useIsAuth";

import "./style/UserPage.scss";
import { useEffect } from "react";
import { metrics } from "utils/metrics";
import { WithSideAds } from "../../components/ads";
import { ProfilePageSkyscraperEnum } from "../../components/ads/config/units/profilePageSkyscraper";
import { PageNotFound, REMOVED_USER, NOT_FOUND } from "components/page-not-found/PageNotFound";

const validateUserId = (id: string | undefined): string => {
  if (id === undefined) {
    throw new Error("user id not specified");
  }

  return id;
};

export const UserPage = () => {
  const { id } = useParams();
  const query = useUserInfo(validateUserId(id));
  const userName = useUserName();

  useEffect(() => {
    const gaUserView = async () => {
      if (userName) {
        await metrics.sendProfileView({ userName: userName });
      }
    };
    gaUserView();
  }, [userName]);

  if (query.isLoading) {
    return <p>Loading user data…</p>;
  }

  // @ts-ignore
  // eslint-disable-next-line no-magic-numbers
  if (query.isError && query?.error?.response?.status === 410) {
    return <PageNotFound pageType={REMOVED_USER} />;
  }

  if (query.data === undefined) {
    return <PageNotFound pageType={NOT_FOUND} />;
  }

  const isMyself = userName === query.data.username;

  return (
    <WithSideAds
      leftAds={[
        ProfilePageSkyscraperEnum.ProfilePageSkyscraperL1,
      ]}
      rightAds={[
        ProfilePageSkyscraperEnum.ProfilePageSkyscraperR1,
      ]}
    >
      <div className="wide page creatorPage">
        <CreatorInfo myself={isMyself} user={query.data} />

        {!isMyself && <UserGifList id={query.data.username} />}

        {isMyself && <MyGifList id={query.data.username} />}
      </div>
    </WithSideAds>
  );
};
